import { useQuery } from '@apollo/client';
import OFFERS_DATE_INFORMATION from '../graphql/queries/factoring/offers-date-information';

const getSelectedInvoicesDateInformation = (shoppingCartOffers) => {
  const {
    data,
  } = useQuery(OFFERS_DATE_INFORMATION, {
    variables: {
      id_In: shoppingCartOffers.map((offer) => offer.invoiceId),
    },
  });

  return data;
};

export default getSelectedInvoicesDateInformation;
